import {SmallLoader} from '@kit';

import React from 'react';

import {useSubClassesClassQuery} from '../../../generated/types';
import {getApolloError} from '../../../components/utils';
import {EditHoc} from '../../../components/edit-hoc';
import {Link} from '../../../lib/routes';
import {Markdown} from '../../../components/utils/md';

import pageCss from '../../../components/common.module.css';

type Props = {
	classId: string;
};

export const ClassSubClasses: React.FC<Props> = ({classId}) => {
	const {data, loading, error} = useSubClassesClassQuery({variables: {id: classId}});
	const heroClass = data?.class;
	return (
		<>
			{loading && (
				<div className={pageCss.fullSizeBlock}>
					<SmallLoader />
				</div>
			)}
			{error && <div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>}

			{heroClass && (
				<div>
					<EditHoc
						load={() => import('../edit-buttons').then((m) => m.EditSubClassDescription)}
						editProps={{id: heroClass.id!}}
					>
						<Markdown text={heroClass.subClassDescription} />
					</EditHoc>
					{heroClass.subClasses?.map((subClass) => (
						<EditHoc
							key={subClass.id}
							load={() => import('../edit-buttons').then((m) => m.EditSubClass)}
							editProps={{classId: heroClass.id!, id: subClass.id}}
						>
							<h2>
								<Link route={'subClass'} params={{id: classId, subClassId: subClass.id}}>
									{subClass.title}
								</Link>
							</h2>

							<Markdown text={subClass.shortDescription ?? ""} />
						</EditHoc>
					))}
				</div>
			)}
		</>
	);
};
